angular.module('tgaAdmin').controller('GameTransferModalController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  'userService',
  'gameService',
  'extras',
  '$translate',
  function ($scope, $state, $window, $uibModalInstance, $uibModalStack, userService, gameService, extras, $translate) {
    $scope.data = {
      alerts: [],
      closeButton: true,
      users: [],
    };

    $scope.viewmodel = {
      transfer_from: extras.transfer_from,
      transfer_to: null,
    };

    $scope.initialize = function () {
      userService
        .getUsersList()
        .then((users) => {
          $scope.data.users = users.filter((x) => x.id !== $scope.viewmodel.transfer_from.id);
        })
        .catch((error) => {
          $scope.actions.createAlert(error);
        });
    };

    $scope.actions = {
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $uibModalStack.getTop().value.backdrop = 'static';
        $uibModalStack.getTop().value.keyboard = false;
        $scope.data.closeButton = false;

        $scope.processing = true;

        gameService
          .transferGames({
            transfer_from: $scope.viewmodel.transfer_from.id,
            transfer_to: $scope.viewmodel.transfer_to.id,
          })
          .then(() => {
            $uibModalInstance.close();
          })
          .catch((error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            $scope.processing = false;
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
    $scope.initialize();
  },
]);
